import React from 'react';

import { OfferOption } from '../../utils/backend-api/subscribe';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import Offers from './Offers';

interface MultipleOffersProps {
  offers: OfferOption[];
  selectedOffer: SelectedOffer;
  setSelectedOffer: (plan: SelectedOffer) => void;
}

const MultipleOffers = ({ offers, selectedOffer, setSelectedOffer }: MultipleOffersProps) => {
  return (
    <div>
      <div className="mb-20 mt-24 flex items-center">
        <div className="font-sans text-body-sm font-bold uppercase text-primary-red">
          Choose Plan
        </div>
        <div className="ml-12 h-2 flex-1 bg-primary-red"></div>
      </div>
      <Offers
        offers={offers}
        selectedOfferCode={selectedOffer.code}
        setSelectedOffer={setSelectedOffer}
      />
    </div>
  );
};

export default MultipleOffers;
